import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'app-cbc-date-filed-cell-viewer',
  templateUrl: './cbc-date-filed-cell-viewer.component.html',
  styleUrls: ['./cbc-date-filed-cell-viewer.component.scss']
})
export class CbcDateFiledCellViewerComponent implements OnInit, CellComponent {

  item: any;
  fieldDefinition: any;
  sourceType: string;
  fieldDefinitionKeyModel = '';
  valueChanged: EventEmitter<any> = new EventEmitter();


  constructor() { }

  ngOnInit(): void {
    console.log("Working");
    this.fieldDefinitionKeyModel = this.fieldDefinition.key+'_Model';
  }

  emitSidebarData() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: 'CbcFilingDateFiledClicked'}});
  }

  openNote() {
    
  }
}
